import { AnalyticIdentifier, MonthYear, stringToMonthYear, toMonthYearString } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

import { MonthYearPicker } from '../../month-year-picker';
import { ValueInputType } from './types';

export const MonthYearValueInput: ValueInputType = ({ onChange, rowNumber, value }): React.ReactElement => {
  const pickerId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_FILTER_MONTH_YEAR_INPUT, { postfix: rowNumber });
  const clearButtonId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_FILTER_MONTH_YEAR_CLEAR_BUTTON, {
    postfix: rowNumber,
  });

  const monthYear = value ? stringToMonthYear(value.toString()) : undefined;
  const handleChange = (monthYear: MonthYear | null): void => {
    if (monthYear === null) {
      return;
    }
    onChange(toMonthYearString(monthYear));
  };

  return (
    <MonthYearPicker
      id={pickerId}
      clearButtonId={clearButtonId}
      value={monthYear}
      onChange={handleChange}
      monthPlaceholder="Month"
      yearPlaceholder="Year"
    />
  );
};
